import React, { useEffect, useState } from 'react';
import Filters from '../../../components/Filter';
import { NavigationProp, RouteProp, useNavigation } from '@react-navigation/native';
import { AppAgentParamList } from '../../../typings/Params';
import { DebuggerSubTag, DebuggerTag, tags as tagsType } from './Debugger';
import DebuggerTagsDropdown from './DebuggerTagsDropdown';
import DebuggerSubTagsDropdown from './DebuggerSubTagsDropdown';

interface Props {
    filters: AppAgentParamList['Debugger'];
    setFilters: React.Dispatch<React.SetStateAction<AppAgentParamList['Debugger']>>;
}

function sameElements(a: unknown[], b: unknown[]) {
    if (a.length !== b.length) {
        return false;
    }

    const aa = [...a].sort();
    const bb = [...b].sort();

    return aa.every((v, i) => v === bb[i]);
}

function Filter({ filters, setFilters }: Props) {
    const navigation = useNavigation<NavigationProp<RouteProp<AppAgentParamList, 'Debugger'>>>();

    const [tags, setTags] = useState<DebuggerTag[]>(filters.tags ?? []);
    const [subTags, setSubTags] = useState<DebuggerSubTag[]>(filters.subTags ?? []);

    const [subTagItems, setSubTagItems] = useState<DebuggerSubTag[]>([]);

    const handleCleanFilter = () => {
        setTags([]);
        setSubTags([]);
    };

    useEffect(() => {
        const subTagItems: DebuggerSubTag[] = [];
        const newSubTags: DebuggerSubTag[] = [];

        for (const tag of tags) {
            subTagItems.push(...tagsType[tag]);
            newSubTags.push(...subTags.filter(subTag => tagsType[tag].includes(subTag)));
        }

        setSubTagItems(subTagItems);
        if (!sameElements(subTags, newSubTags)) {
            setSubTags(newSubTags);
        }
    }, [tags, subTags]);

    const handleFilter = () => {
        navigation.setParams({ tags, subTags });
        setFilters({ tags, subTags });
    };

    return (
        <Filters onCleanFilters={handleCleanFilter} onFilters={handleFilter}>
            <DebuggerTagsDropdown
                value={tags}
                setValue={setTags}
                zIndex={3}
            />
            <DebuggerSubTagsDropdown
                items={subTagItems}
                value={subTags}
                setValue={setSubTags}
                zIndex={2}
            />
        </Filters>
    );
}

export default Filter;
